import * as React from 'react';
import {FormControlLabel, Button} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout'
import { logout_axios } from '../services/auth-service';
import { useAuth } from '../contexts/AuthContext';
import { useHistory } from 'react-router';

// import { useISUContext, Levels } from '../pages/Gui/gui';

interface Props {
  loggedIn: boolean,
  userPayload: any,
  // setloggedIn: any
}
export default function LogoutButton() {
  
  const history = useHistory()
  const { clearsession } = useAuth()
    const handleLogoutClick = () => {
      // const checked = event.target.checked
      // console.log(event)
      console.log('View from logout_btn')
      // Trigger Backend Logout Procedure
      logout_axios()

      // Clear User Sessoin Procedure.
      clearsession();

      window.location.href = "login"
      // history.push("/login")
  }

  return (
    <React.Fragment>
      <Button onClick={handleLogoutClick} color="secondary" variant="contained" endIcon={<LogoutIcon/>} sx={{marginLeft: '1em'}}>LogOut</Button>
    </React.Fragment>
  );
}
